module.exports = __webpack_public_path__ + "assets/img/zh8.ab2e87a6.png";